<template>
<!-- 司机评价 -->
  <div class="user_container">
    <!-- 搜索 -->
    <div class="container_top">
      <el-select
        v-model="valueWeek"
        placeholder="请选择"
        class="selectWeek"
        @change="changeWeek"
      >
        <el-option
          v-for="item in optionWeek"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
      <el-select
        v-model="valueMonth"
        placeholder="请选择"
        class="selectMonth"
        @change="changeMonth"
      >
        <el-option
          v-for="item in optionMonth"
          :key="item.value"
          :label="item.label"
          :value="item.value"
        >
        </el-option>
      </el-select>
    </div>
    <!-- 司机评价列表 -->
    <template v-if="tableData.length > 0">
      <div v-for="item in tableData" :key="item.id" class="box_content">
        <div class="content">
          <div class="field">
            <div class="field_label">司机姓名：</div>
            <div class="field_value">{{ item.driverName }}</div>
          </div>
          <div class="field">
            <div class="field_label">车牌号：</div>
            <div class="field_value">{{ item.carBrand }}</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}接单数：</div>
            <div class="field_value">{{ item.weekOrderNum }}单</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}个人排名：</div>
            <div class="field_value">{{ item.weekRank }}</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}收获评价数：</div>
            <div class="field_value">{{ item.weekToolCommentNum }}</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}综合评分：</div>
            <div class="field_value">{{ item.weekAverageScore }}分</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}投诉数量：</div>
            <div class="field_value">{{ item.weekBadCommentNum }}条</div>
          </div>
          <div class="field">
            <div class="field_label">历史个人排名：</div>
            <div class="field_value">{{ item.totalRank }}</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}好评数：</div>
            <div class="field_value">{{ item.weekGoodCommentNum }}</div>
          </div>
          <div class="field">
            <div class="field_label">历史综合评分：</div>
            <div class="field_value">{{ item.totalAverageScore }}</div>
          </div>
          <div class="field">
            <div class="field_label">{{ week }}好评率：</div>
            <div class="field_value">{{ item.weekGoodCommentRadio }}%</div>
          </div>
          <div class="field">
            <div class="field_label">环比上{{ week }}：</div>
            <div
              class="field_value"
              v-if="item.weekGoodCommentRadioChainRadio > 0"
            >
              {{ "+" + item.weekGoodCommentRadioChainRadio + "%" }}
            </div>
            <div
              class="field_value"
              v-else-if="item.weekGoodCommentRadioChainRadio < 0"
            >
              {{ "-" + item.weekGoodCommentRadioChainRadio + "%" }}
            </div>
            <div class="field_value" v-else>
              {{ item.weekGoodCommentRadioChainRadio + "%" }}
            </div>
          </div>
        </div>
      </div>
    </template>
    <div v-else style="text-align: center;margin-top: 50px;">
      当前区域暂无司机...
    </div>
  </div>
</template>

<script>
// import api from "@/apis";
import apiCar from "@/apis/car";

// import { getToken, setToken } from "@/utils/cookie";
export default {
  name: "detail",
  props: {},
  components: {},
  data() {
    return {
      tableData: [],
      startDate: "",
      endDate: "",
      valueWeek: 0,
      valueMonth: 1,
      week: "周",
      optionWeek: [],
      optionMonth: [
        {
          value: 1,
          label: "周报",
        },
        {
          value: 2,
          label: "月报",
        },
        {
          value: 3,
          label: "年报",
        },
      ],
    };
  },
  created() {},
  mounted() {
    // const { startDate, endDate } = this.$route.query;
    // this.startDate = startDate;
    // this.endDate = endDate;
    // this.getList();
    this.getSelect();
    // let token = getToken();
    // if (token) {
    //   this.getUserToken(token);
    // } else {
    //   this.$bus.$on("processToken", (res) => {
    //     this.getUserToken(res);
    //   });
    // }
  },
  methods: {
    //获取司机评价列表
    getList() {
      apiCar
        .weekCommentCountByLeader({
          startDate: this.startDate,
          endDate: this.endDate,
          dateType: this.valueMonth,
          zoneId: localStorage.getItem("cityId"),
        })
        .then((data) => {
          if (data.code == 200) {
            this.tableData = data.data;
          }
        });
    },
    //获取日期范围
    getSelect() {
      apiCar.queryDateRange({ dateType: this.valueMonth }).then((data) => {
        if (data.code == 200) {
          const res = data.data;
          this.optionWeek = res;
          this.optionWeek.forEach((item, i) => {
            item.value = i;
            item.label = item.startTime + "到" + item.endTime;
          });
          this.startDate = this.optionWeek[0].startTime;
          this.endDate = this.optionWeek[0].endTime;
          this.valueWeek = 0;
          this.getList();
        }
      });
    },
    //选择日期范围
    changeMonth(val) {
      if (val == 1) {
        this.week = "周";
      } else if (val == 2) {
        this.week = "月";
      } else {
        this.week = "年";
      }
      this.getSelect();
    },
    //选择时间范围
    changeWeek(val) {
      const index = this.optionWeek.find((item) => item.value == val);
      this.startDate = index.startTime;
      this.endDate = index.endTime;
      this.getList();
    },
    // getUserToken(empNo) {
    //   if (empNo) {
    //     let thisname = empNo;
    //     api.queryByUsername({ username: thisname }).then((data) => {
    //       const info = data.data;
    //       console.log(info, "info");

    //       // this.$store.commit("changeUserInfo", info);
    //       setToken(empNo);
    //     });
    //   }
    // },
    //跳转司机评价详情
    toUrl(row) {
      this.$router.push({
        path: "/car/evaluate/driverWeeklyDetail",
        query: {
          startDate: this.startDate,
          endDate: this.endDate,
          driverCode: row.driverCode,
          name: row.driverName,
        },
      });
    },
  },
};
</script>

<style lang="scss" scoped>
$zoom: 1020 / 375;

@media screen and (max-width: 600px) {
  .user_container {
    width: 100%;
  }
}

@media screen and (min-width: 600px) {
  .user_container {
    width: 276px * $zoom;
  }
}
.user_container {
  min-height: 100vh;
  //   padding: 30px;
  margin: auto;
  font-size: 1vh;
  font-size: 26px;
  //   position: relative;
  overflow: hidden;
  .container_top {
    // height: 100px;
    display: flex;
    align-items: center;
    justify-content: space-between;
    font-size: 32px;
    padding: 20px 30px;
    ::v-deep {
      .el-input__inner {
        height: 80px !important;
        border-radius: 12px !important;
        font-size: 28px;
      }
      .selectWeek {
        width: 60% !important;
      }
      .selectMonth {
        width: 22% !important;
      }
    }
  }
  .box_content {
    margin: 0 30px;
  }
  .content {
    display: flex;
    align-content: center;
    justify-content: space-between;
    flex-wrap: wrap;
    background: #fff;
    border-radius: 20px;
    padding: 30px 30px 20px;
    margin-bottom: 30px;
    font-size: 28px;
    .field {
      width: 50%;
      display: flex;
      align-items: center;
      margin-bottom: 20px;
      .field_label {
        color: rgba(102, 102, 102, 1);
      }
      .field_value {
      }
    }
    .field_width {
      width: 100%;
    }
  }
}

::v-deep {
  thead .el-table__cell {
    font-size: 26px;
    background: rgba(247, 249, 250, 1);
    font-weight: none;
  }
  .el-table .cell {
    font-size: 26px;
    line-height: 60px;
    color: #000;
  }
}
</style>
